HB.onReady(() => {
  if (!document.querySelector(".layout-places_new, .layout-places_create")) {
    return
  }

  const label = document.querySelector(".place_total_number_of_rooms label")
  const input = document.querySelector('select[name="place[property_type_id]"]')

  if (!label || !input) return

  const updateLabel = () => {
    const selectedOption = input.selectedOptions[0]
    if (!selectedOption) return
    const propertyType = selectedOption.dataset.alias
    label.textContent =
      propertyType === "villa" ? label.dataset.villa : label.dataset.default
  }

  if (input.selectedOptions.length > 0) {
    updateLabel()
  }

  input.addEventListener("change", updateLabel)
})
